const data = [
  {
    id: 'a',
    src: '/images/vincent-van-zalinge-bird.jpg',
    alt: 'A tiny shrewd turquoise-and-amber bird',
    tags: [
      'bird',
      'blurred background',
      'wildlife',
      'animal in its natural habitat',
    ],
  },
  {
    id: 'b',
    src: '/images/alexandru-rotariu-dog.jpg',
    alt: 'A serious-looking grey dog with cool glacier eyes',
    tags: ['dog', 'HD'],
  },
  {
    id: 'c',
    src: '/images/scott-walsh-fox.jpg',
    alt: 'A happy-looking cute wild fox in nature, near some pink flowers',
    tags: ['fox', 'flowers'],
  },
  {
    id: 'd',
    src: '/images/andy-holmes-giraffe.jpg',
    alt: 'A giraffe sticking its black tongue out',
    tags: ['giraffe', 'dramatic'],
  },
  {
    id: 'e',
    src: '/images/karsten-winegeart-dog.jpg',
    alt: 'A small dog wearing a golden "Champions" hoodie',
    tags: ['dog', 'cute', 'animal wearing human clothes'],
  },
  {
    id: 'f',
    src: '/images/marko-blazevic-cat.jpg',
    alt: 'A small kitten standing on its back legs, reaching up towards the camera',
    tags: ['kitten', 'cat', '#cute'],
  },
  {
    id: 'g',
    src: '/images/mark-stoop-lizard.jpg',
    alt: 'A relaxed green lizard, sitting on a wooden beam',
    tags: [
      'lizard',
      'world-famous insurance salesman from the commercials',
    ],
  },
  {
    id: 'h',
    src: '/images/geran-de-klerk-squirrel.jpg',
    alt: 'A fuzzy squirrel, highlighted in a dark backdrop',
    tags: ['squirrel', 'animal', 'fuzzy'],
  },
  {
    id: 'i',
    src: '/images/wexor-tmg-turtle.jpg',
    alt: 'A large tropical turtle swimming in water',
    tags: ['turtle', 'ocean', 'flippers'],
  },
];

export default data;
